import React from 'react';

import useEvent from '@lyearn/core/hooks/useEvent';
import useScreen from '@lyearn/core/hooks/useScreen';
import { PopoverContentPosition } from '@lyearn/ui';
import { Popover } from '@lyearn/ui';
import { ProjectStageEntityConfig } from '@/components/FilterManager/EntityFilter/entity/project-stage';
import FilterBody from '@/components/FilterNew/components/Body';
import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import { NewFilterOption } from '@/components/FilterNew/types';
import { StageConfigSchema } from '@/types/schema';

const LIST_CONFIG: FilterBodyListConfig = {
  ...ProjectStageEntityConfig,
  listVariant: 'single-ungrouped-finite',
};

function ProjectStageMenu({
  stageId,
  projectId,
  children,
  popoverPosition,
  onStageChange,
  disabled,
}: {
  stageId?: string;
  projectId?: string;
  children: React.FC<{
    selectedOptions: NewFilterOption<
      Pick<StageConfigSchema, 'stageId' | 'name' | 'iconSettings'>
    >[];
  }>;
  popoverPosition?: PopoverContentPosition;
  onStageChange: (id?: string) => void;
  disabled?: boolean;
}) {
  const onChange = useEvent((value: NewFilterOption[]) => {
    const nextStageId = value?.[0]?.value;
    if (nextStageId === stageId) {
      onStageChange(undefined);
    } else {
      onStageChange(nextStageId);
    }
  });
  const { isMobile } = useScreen();

  const selectedFilterValuesData = LIST_CONFIG.useFilterValues({
    value: stageId ? [stageId] : [],
    queryParams: {
      projectId,
    },
  });

  return (
    <Popover>
      {({ open, onOpenChange }) => (
        <>
          <Popover.Button disabled={disabled}>
            {children({
              selectedOptions: selectedFilterValuesData.selectedOptions as NewFilterOption<any>[],
            })}
          </Popover.Button>
          {open ? (
            <Popover.Content
              position={popoverPosition}
              renderAs={isMobile ? 'bottom-sheet' : 'popover'}>
              <FilterBody
                initialSelectedOptions={selectedFilterValuesData.selectedOptions}
                listConfig={LIST_CONFIG}
                queryParams={{
                  projectId,
                }}
                onChange={onChange}
                onToggle={onOpenChange}
              />
            </Popover.Content>
          ) : null}
        </>
      )}
    </Popover>
  );
}

export default ProjectStageMenu;
